const FECHA_FORMATTERS_AR = {
    iso: new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'America/Argentina/Buenos_Aires'
    }), // YYYY-MM-DD
    ar: new Intl.DateTimeFormat('es-AR', {
        timeZone: 'America/Argentina/Buenos_Aires',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }) // DD/MM/YYYY
};

const FORMATO_FECHA = {
    ISO: 'iso',
    AR: 'ar'
};

export {
    FECHA_FORMATTERS_AR,
    FORMATO_FECHA
};